import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import { i18n } from "@/i18n";
import ModelsView from "@/views/ModelsView.vue";
import ModelView from "@/views/ModelView.vue";
import TypesView from "@/views/TypesView.vue";
import VehicleView from "@/views/VehicleView.vue";
import GalleryView from "@/views/GalleryView.vue";
import WebView from "@/views/WebView.vue";
import ErrorView from "@/views/ErrorView.vue";
import LoginView from "@/views/LoginView.vue";
import LayoutView from "@/views/LayoutView.vue";

const routes = [
  {
    path: "/",
    redirect: { name: "Login" },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: {
      title: i18n.global.t("login"),
      mode: "out-in",
    },
  },
  {
    path: "/error",
    name: "Error",
    component: ErrorView,
    meta: {
      title: i18n.global.t("error"),
      back: 74,
      backRoute: { name: "Home" },
    },
  },
  {
    path: "/secured",
    name: "Secured",
    component: LayoutView,
    redirect: { name: "Home" },
    children: [
      {
        path: "home",
        name: "Home",
        component: HomeView,
        meta: {
          title: 18,
          mode: "out-in",
        },
      },
      {
        path: "models",
        name: "Models",
        component: ModelsView,
        meta: {
          title: 500,
          back: 74,
          backRoute: { name: "Home" },
          mode: "out-in",
        },
      },
      {
        path: "model/:range",
        name: "Model",
        component: ModelView,
        meta: {
          title: 500,
          back: 533,
          backRoute: { name: "Models" },
          mode: "out-in",
        },
      },
      {
        path: "types/:range",
        name: "Types",
        component: TypesView,
        meta: {
          title: 504,
          titleColor: "blue",
          back: 533,
          backRoute: { name: "Models" },
          transition: "slide-left",
        },
      },
      {
        path: "vehicle/:range/:vehicle",
        name: "Vehicle",
        component: VehicleView,
        meta: {
          title: "AIXAM",
          back: 502,
          backRoute: { name: "Types" },
          transition: "slide-left",
        },
      },
      {
        path: "vehicle/:range/:vehicle/gallery",
        name: "Gallery",
        component: GalleryView,
        meta: {
          title: 193,
          back: 74,
          backRoute: { name: "Vehicle" },
          transition: "slide-left",
        },
      },
      {
        path: ":type(configurator)",
        name: "Configurator",
        component: WebView,
        meta: {
          title: 236,
          back: 74,
          backRoute: { name: "Home" },
        },
      },
      {
        path: ":type(jpo)",
        name: "JPO",
        component: WebView,
        meta: {
          title: 532,
          back: 74,
          backRoute: { name: "Home" },
        },
      },
      {
        path: ":type(about)",
        name: "About",
        component: WebView,
        meta: {
          title: i18n.global.t("all_about_aixam"),
          back: 74,
          backRoute: { name: "Home" },
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.authRequired) {
//   }
//   next();
// });

router.afterEach((to, from) => {
  const toDepth = to.path.split("/").length;
  const fromDepth = from.path.split("/").length;
  if (to.meta.transition === "slide-left") {
    to.meta.transition = toDepth < fromDepth ? "slide-right" : "slide-left";
  }
});
export default router;
